import { defineComponent as _defineComponent } from 'vue'
interface IProps {
  title?: string;
  content?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertCard',
  props: {
    title: null,
    content: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})